import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  },
  tableContainer: {
    maxHeight: 500
  }
});

export default function TablePreviewXLSX ({ headers, rows, setSelectedDataItem }) {
  const classes = useStyles();
  const [selected, setSelected] = useState();

  const handleClick = (index, individualExcelData) => {
    if (setSelectedDataItem) {
      setSelected(index);
      setSelectedDataItem(individualExcelData);
    }
  };

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <Table className={classes.table} aria-label='simple table'>
        <TableHead style={{ backgroundColor: '#cacaca' }}>
          <TableRow>
            { headers.map((header) => (
              <TableCell align='left' key={header}>{ header }</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          { rows.map((individualExcelData, index) => {
            return (
              <TableRow
                style={{
                  cursor: setSelectedDataItem && 'pointer'
                }}
                onClick={() => handleClick(index, individualExcelData)}
                key={index}
                selected={index === selected}
              >
                {Object.keys(individualExcelData).map((key) => (
                  <TableCell align='left' key={key}>{individualExcelData[key]}</TableCell>
                ))}
              </TableRow>);
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

TablePreviewXLSX.propTypes = {
  headers: PropTypes.array,
  rows: PropTypes.array
};
